// extracted by mini-css-extract-plugin
module.exports = {"itemCaution":"SerialCodeModal_itemCaution__0TI8D","textSerialCode":"SerialCodeModal_textSerialCode__Fyzw1","contentWrapper":"SerialCodeModal_contentWrapper__Pt6PM"};